import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isMarketerReadOnly, isMarketerPathAllowed } from "../../helpers/adminRole";

/**
 * Redirects role=marketer away from any route not in their allowlist.
 */
const MarketerRouteGuard = ({ children }) => {
  const { pathname } = useLocation();
  if (isMarketerReadOnly() && !isMarketerPathAllowed(pathname)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

export default MarketerRouteGuard;
